import React from 'react';
import { connect } from 'react-redux';
import { Select, Button } from 'antd';
import Preloader from '../../Preloader/Preloader';
import DownloadDataWrapper from './DownloadData.style';
import { getDataToDownloadList, setDataToDownloadType, setDataToDownloadIc, setDataToDownloadChannel, DownloadDataSet } from '../../../redux/actions/IC/ICActions';

const Option = Select.Option;

class DownloadData extends React.Component {

  constructor() {
    super();
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleIcChange = this.handleIcChange.bind(this);
    this.handleDataDownload = this.handleDataDownload.bind(this);
    this.handleChannelChange = this.handleChannelChange.bind(this);
  }

  componentDidMount() {
    this.props.getDataToDownloadList();
    this.props.setDataToDownloadType('');
    this.props.setDataToDownloadIc('');
    this.props.setDataToDownloadChannel('');
  }

  handleDataDownload() {
    this.props.DownloadDataSet(this.props.ICREDUCER.data_to_download.type, this.props.ICREDUCER.data_to_download.ic_code, this.props.ICREDUCER.data_to_download.channel)
  }

  handleTypeChange(value) {
    this.props.setDataToDownloadType(value);
  }

  handleIcChange(value) {
    this.props.setDataToDownloadIc(value);
  }

  handleChannelChange(value) {
    this.props.setDataToDownloadChannel(value);
  }
  
  render() {
    if(this.props.APPREDUCER.showPreloader === true) {
      return(
        <Preloader />
      )
    }
    else {
      
      let type_list = this.props.ICREDUCER.data_to_download.data.length
      ?
      this.props.ICREDUCER.data_to_download.data
      .map((data,i) => <Option key={i} value={data.type}>{data.type}</Option>)
      :
      [];

      let ic_list = this.props.ICREDUCER.data_to_download.type.length
      ?
      this.props.ICREDUCER.data_to_download.data
      .filter(data => data.type === this.props.ICREDUCER.data_to_download.type )[0].ic
      .map((ic,i) => typeof(ic) === 'object'
      ?
      <Option key={i} value={ic.ic_code}>{ic.ic_code}</Option>
      :
      <Option key={i} value={ic}>{ic}</Option> )
      :
      [];

      let calc_exc_fields_list = this.props.ICREDUCER.data_to_download.ic_code.length
      ?
      this.props.ICREDUCER.data_to_download.data
      .filter(data => data.type === this.props.ICREDUCER.data_to_download.type)[0].ic
      .filter((ic,i) => typeof(ic) === 'object' ? ic.ic_code === this.props.ICREDUCER.data_to_download.ic_code : ic === this.props.ICREDUCER.data_to_download.ic_code  )
      :
      [];

      calc_exc_fields_list = typeof(calc_exc_fields_list[0]) === 'object' 
      ?
      calc_exc_fields_list[0].calc_exc_fields
      .map((field,i) => <Option key={i} value={field}>{field}</Option>)
      :
      [];

      let is_download_enabled = this.props.ICREDUCER.data_to_download.type.length ? false : true;

      return(
        <DownloadDataWrapper>
          
          <h2>Download Data section goes here</h2>
          
          <Select placeholder="Select Type of Data To Download" style={{ width: 300, margin: 10 }} onChange={this.handleTypeChange}>
            {type_list}
          </Select>

          <Select showSearch placeholder="Select IC Based on Above Type of Data" style={{ width: 300, margin: 10 }} onChange={this.handleIcChange} disabled={ ic_list.length ? false : true }>
            {ic_list}
          </Select>

          <Select placeholder="Select Channel (if any) for which data is to be downloaded" style={{ width: 300, margin: 10 }} onChange={this.handleChannelChange} disabled={ calc_exc_fields_list.length ? false : true }>
            {calc_exc_fields_list}
          </Select>

          <Button type="primary" disabled={is_download_enabled} onClick={this.handleDataDownload} icon="download">Download</Button>

        </DownloadDataWrapper>
      )
    }
  }
}

function mapStateToProps(state) {
  return state
}

const mapDispatchToProps = {
  getDataToDownloadList,
  setDataToDownloadType,
  setDataToDownloadIc,
  setDataToDownloadChannel,
  DownloadDataSet
};

export default connect(mapStateToProps,mapDispatchToProps)(DownloadData);


// WEBPACK FOOTER //
// ./src/components/IC/DownloadData/DownloadData.js